import { InsuranceMonitor } from "@wingspanhq/wingspan-api-sdk";

import {
  RequirementContextType,
  RequirementTableItemData
} from "../../../../types";

import { getInsuranceCoverageRequirementStatus } from "./getInsuranceCoverageRequirementStatus";

export const getInsuranceCoveragePayeeRequirementStatus = (
  requirement: RequirementTableItemData,
  insuranceMonitor: InsuranceMonitor | undefined
) => {
  // For payee view, use the same logic as general status
  return getInsuranceCoverageRequirementStatus(
    requirement,
    insuranceMonitor,
    RequirementContextType.Payee
  );
};
